module.exports = __webpack_public_path__ + "static/images/icon-ubisoft.2d940d3613de316a5ddfc1aeab36419d.svg";